exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container {\r\n    padding: 20px;\n}\r\n", ""]);

// exports
